// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__19ui_","header":"MergedInvoice_header__1-geA"};